import { Task } from "../../lib/api/tasks";

interface TaskFiltersProps {
  tasks: Task[];
  onFilterChange: (filters: TaskFilters) => void;
  filters: TaskFilters;
}

export interface TaskFilters {
  assigneeId?: string;
  priority?: Task["priority"];
  type?: Task["type"];
  search?: string;
}

export function TaskFilters({
  tasks,
  onFilterChange,
  filters,
}: TaskFiltersProps) {
  // Get unique assignees from tasks
  const assignees = Array.from(
    new Set(tasks.filter((t) => t.assigneeId).map((t) => t.assigneeId)),
  );

  // Get unique priorities from tasks
  const priorities = Array.from(
    new Set(tasks.map((t) => t.priority)),
  ) as Task["priority"][];

  // Get unique types from tasks
  const types = Array.from(new Set(tasks.map((t) => t.type))) as Task["type"][];

  return (
    <div className="mb-6 flex flex-wrap gap-4">
      <input
        type="text"
        placeholder="Search tasks..."
        value={filters.search || ""}
        onChange={(e) =>
          onFilterChange({ ...filters, search: e.target.value || undefined })
        }
        className="px-4 py-2 border rounded flex-grow"
      />

      <select
        value={filters.assigneeId || ""}
        onChange={(e) =>
          onFilterChange({
            ...filters,
            assigneeId: e.target.value || undefined,
          })
        }
        className="px-4 py-2 border rounded min-w-[150px]"
      >
        <option value="">All Assignees</option>
        {assignees.map((assigneeId) => (
          <option key={assigneeId} value={assigneeId}>
            {assigneeId}
          </option>
        ))}
      </select>

      <select
        value={filters.priority || ""}
        onChange={(e) =>
          onFilterChange({
            ...filters,
            priority: (e.target.value as Task["priority"]) || undefined,
          })
        }
        className="px-4 py-2 border rounded min-w-[150px]"
      >
        <option value="">All Priorities</option>
        {priorities.map((priority) => (
          <option key={priority} value={priority}>
            {priority}
          </option>
        ))}
      </select>

      <select
        value={filters.type || ""}
        onChange={(e) =>
          onFilterChange({
            ...filters,
            type: (e.target.value as Task["type"]) || undefined,
          })
        }
        className="px-4 py-2 border rounded min-w-[150px]"
      >
        <option value="">All Types</option>
        {types.map((type) => (
          <option key={type} value={type}>
            {type}
          </option>
        ))}
      </select>

      {(filters.assigneeId ||
        filters.priority ||
        filters.type ||
        filters.search) && (
        <button
          onClick={() => onFilterChange({})}
          className="px-4 py-2 text-gray-600 hover:text-gray-800"
        >
          Clear Filters
        </button>
      )}
    </div>
  );
}
